export default __webpack_public_path__ + "c0d5272d144366f37bbaebd88f1b9a8e.png";